import { render, staticRenderFns } from "./ResetBusesWarningModal.vue?vue&type=template&id=36f58ec8&scoped=true&"
import script from "./ResetBusesWarningModal.vue?vue&type=script&lang=js&"
export * from "./ResetBusesWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetBusesWarningModal.vue?vue&type=style&index=0&id=36f58ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f58ec8",
  null
  
)

export default component.exports